// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Figma prototype: Smart Animate, ease-out, 300ms — both for opening and closing */
.bottomSheet-module_overlay__Vajiz,
.bottomSheet-module_fullScreen__XdlxJ {
    --bs-animation-duration: 300ms;
}

.bottomSheet-module_overlay__Vajiz {
    align-items: center;
    background: var(--black_48_tr_base);
    bottom: 0;
    display: block;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: var(--zindex-modal-index);
    animation: bottomSheet-module_overlayIn___bsVz var(--bs-animation-duration) ease-out;
}

.bottomSheet-module_overlayClosing__tr78J {
    animation-name: bottomSheet-module_overlayOut__JiR96;
    animation-fill-mode: forwards;
}

.bottomSheet-module_popupOuter__mDRTK {
    align-items: flex-end;
    display: flex;
    justify-content: center;
    height: 100%;
    padding: 0 16px;

    @media screen and (min-width: 708px) {
        align-items: center;
    }
}

.bottomSheet-module_popupBoxContentWrapper__GtsAx {
    background: var(--white);
    border-radius: 12px;
    max-height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding-bottom: 8px;

    @media screen and (min-width: 708px) {
        border-radius: 16px;
    }
}

.bottomSheet-module_popupBoxContent__fop6Y {
    max-height: 100%;
    overflow-y: auto;
}

.bottomSheet-module_popupBoxButtons__Vgd2h {
    background: var(--white);
    border-radius: 12px;
    padding: 12px 0;
    margin-top: 8px;

    @media screen and (min-width: 708px) {
        border-radius: 16px;
        padding: 16px 0;
    }
}

.bottomSheet-module_popupBox__hfyZU {
    /* Figma Smart Animate: the sheet slides in from just below the viewport edge */
    --bs-offscreen: calc(100% + 24px);
    animation: bottomSheet-module_getInAnimation__HZOaM var(--bs-animation-duration) ease-out;
    overflow: hidden;
    bottom: 24px;
    max-width: 568px;
    max-height: calc(100vh - 48px);
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 708px) {
        bottom: auto;
        border-radius: 16px;
        max-height: calc(100vh - 96px);
        --bs-offscreen: calc(50vh + 50%);
    }
}

.bottomSheet-module_openAnimationName___K4Cn {
    animation-name: bottomSheet-module_getInAnimation__HZOaM;
}

.bottomSheet-module_closeAnimationName__qGU6F {
    animation-name: bottomSheet-module_getOutAnimation__UlrI3;
    animation-fill-mode: forwards;
}

@keyframes bottomSheet-module_getInAnimation__HZOaM {
    from {
        transform: translateY(var(--bs-offscreen, 100%));
    }
}

@keyframes bottomSheet-module_getOutAnimation__UlrI3 {
    to {
        transform: translateY(var(--bs-offscreen, 100%));
    }
}

/* Only the fader fades: animating opacity would fade the sheet inside it too */
@keyframes bottomSheet-module_overlayIn___bsVz {
    from {
        background-color: transparent;
    }
}

@keyframes bottomSheet-module_overlayOut__JiR96 {
    to {
        background-color: transparent;
    }
}

.bottomSheet-module_fullScreen__XdlxJ {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    position: fixed;
    overflow-y: scroll;
    background: var(--white);
    top: 0;
    left: 0;
    z-index: var(--zindex-modal-index);
    animation-duration: var(--bs-animation-duration);
    animation-timing-function: ease-out;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/common/popup/bottomSheet.module.css"],"names":[],"mappings":"AAAA,mFAAmF;AACnF;;IAEI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,SAAS;IACT,cAAc;IACd,uBAAuB;IACvB,OAAO;IACP,eAAe;IACf,QAAQ;IACR,MAAM;IACN,kCAAkC;IAClC,oFAA0D;AAC9D;;AAEA;IACI,oDAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,eAAe;;IAEf;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;IACf,eAAe;;IAEf;QACI,mBAAmB;QACnB,eAAe;IACnB;AACJ;;AAEA;IACI,+EAA+E;IAC/E,iCAAiC;IACjC,yFAA+D;IAC/D,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;;IAEtB;QACI,YAAY;QACZ,mBAAmB;QACnB,8BAA8B;QAC9B,gCAAgC;IACpC;AACJ;;AAEA;IACI,wDAA8B;AAClC;;AAEA;IACI,yDAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA,+EAA+E;AAC/E;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,MAAM;IACN,OAAO;IACP,kCAAkC;IAClC,gDAAgD;IAChD,mCAAmC;AACvC","sourcesContent":["/* Figma prototype: Smart Animate, ease-out, 300ms — both for opening and closing */\n.overlay,\n.fullScreen {\n    --bs-animation-duration: 300ms;\n}\n\n.overlay {\n    align-items: center;\n    background: var(--black_48_tr_base);\n    bottom: 0;\n    display: block;\n    justify-content: center;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: var(--zindex-modal-index);\n    animation: overlayIn var(--bs-animation-duration) ease-out;\n}\n\n.overlayClosing {\n    animation-name: overlayOut;\n    animation-fill-mode: forwards;\n}\n\n.popupOuter {\n    align-items: flex-end;\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    padding: 0 16px;\n\n    @media screen and (min-width: 708px) {\n        align-items: center;\n    }\n}\n\n.popupBoxContentWrapper {\n    background: var(--white);\n    border-radius: 12px;\n    max-height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 8px;\n\n    @media screen and (min-width: 708px) {\n        border-radius: 16px;\n    }\n}\n\n.popupBoxContent {\n    max-height: 100%;\n    overflow-y: auto;\n}\n\n.popupBoxButtons {\n    background: var(--white);\n    border-radius: 12px;\n    padding: 12px 0;\n    margin-top: 8px;\n\n    @media screen and (min-width: 708px) {\n        border-radius: 16px;\n        padding: 16px 0;\n    }\n}\n\n.popupBox {\n    /* Figma Smart Animate: the sheet slides in from just below the viewport edge */\n    --bs-offscreen: calc(100% + 24px);\n    animation: getInAnimation var(--bs-animation-duration) ease-out;\n    overflow: hidden;\n    bottom: 24px;\n    max-width: 568px;\n    max-height: calc(100vh - 48px);\n    position: relative;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n\n    @media screen and (min-width: 708px) {\n        bottom: auto;\n        border-radius: 16px;\n        max-height: calc(100vh - 96px);\n        --bs-offscreen: calc(50vh + 50%);\n    }\n}\n\n.openAnimationName {\n    animation-name: getInAnimation;\n}\n\n.closeAnimationName {\n    animation-name: getOutAnimation;\n    animation-fill-mode: forwards;\n}\n\n@keyframes getInAnimation {\n    from {\n        transform: translateY(var(--bs-offscreen, 100%));\n    }\n}\n\n@keyframes getOutAnimation {\n    to {\n        transform: translateY(var(--bs-offscreen, 100%));\n    }\n}\n\n/* Only the fader fades: animating opacity would fade the sheet inside it too */\n@keyframes overlayIn {\n    from {\n        background-color: transparent;\n    }\n}\n\n@keyframes overlayOut {\n    to {\n        background-color: transparent;\n    }\n}\n\n.fullScreen {\n    width: 100vw;\n    height: 100vh;\n    border-radius: 0;\n    position: fixed;\n    overflow-y: scroll;\n    background: var(--white);\n    top: 0;\n    left: 0;\n    z-index: var(--zindex-modal-index);\n    animation-duration: var(--bs-animation-duration);\n    animation-timing-function: ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `bottomSheet-module_overlay__Vajiz`,
	"fullScreen": `bottomSheet-module_fullScreen__XdlxJ`,
	"overlayIn": `bottomSheet-module_overlayIn___bsVz`,
	"overlayClosing": `bottomSheet-module_overlayClosing__tr78J`,
	"overlayOut": `bottomSheet-module_overlayOut__JiR96`,
	"popupOuter": `bottomSheet-module_popupOuter__mDRTK`,
	"popupBoxContentWrapper": `bottomSheet-module_popupBoxContentWrapper__GtsAx`,
	"popupBoxContent": `bottomSheet-module_popupBoxContent__fop6Y`,
	"popupBoxButtons": `bottomSheet-module_popupBoxButtons__Vgd2h`,
	"popupBox": `bottomSheet-module_popupBox__hfyZU`,
	"getInAnimation": `bottomSheet-module_getInAnimation__HZOaM`,
	"openAnimationName": `bottomSheet-module_openAnimationName___K4Cn`,
	"closeAnimationName": `bottomSheet-module_closeAnimationName__qGU6F`,
	"getOutAnimation": `bottomSheet-module_getOutAnimation__UlrI3`
};
export default ___CSS_LOADER_EXPORT___;
